const REQUEST_ID_HEADER = 'x-request-id';
const CORRELATION_ID_HEADER = 'x-correlation-id';

let currentRequestId: string | null = null;
let currentCorrelationId: string | null = null;

function generateId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
}

function ensureId(): string {
  if (!currentRequestId) currentRequestId = generateId();
  return currentRequestId;
}

export function initRequestId(): string {
  currentRequestId = generateId();
  return currentRequestId;
}

export function getRequestId(): string {
  return ensureId();
}

export function setRequestId(requestId: string): void {
  currentRequestId = requestId;
}

export function getCorrelationId(): string | null {
  return currentCorrelationId;
}

export function setCorrelationId(correlationId: string): void {
  currentCorrelationId = correlationId;
}

export function withRequestIdHeaders(
  base: Record<string, string> = {},
  options: { includeCorrelationId?: boolean } = {},
): Record<string, string> {
  const headers: Record<string, string> = {
    ...base,
    [REQUEST_ID_HEADER]: ensureId(),
  };
  if (options.includeCorrelationId && currentCorrelationId) {
    headers[CORRELATION_ID_HEADER] = currentCorrelationId;
  }
  return headers;
}

export function extractRequestId(headers: Headers): string | null {
  const requestId = headers.get(REQUEST_ID_HEADER) ?? headers.get('X-Request-Id');
  const correlationId = headers.get(CORRELATION_ID_HEADER) ?? headers.get('X-Correlation-Id');

  if (requestId) currentRequestId = requestId;
  if (correlationId) currentCorrelationId = correlationId;

  return requestId;
}
